module.exports = __webpack_public_path__ + "v1.2.5.20250227/img/012.93116ed6.png";